export default [
  {
    "created_at": "2025-05-26T05:59:41.265625Z",
    "updated_at": "2025-06-02T22:24:51.011101Z",
    "featured": false,
    "name": "7 באוקטובר",
    "id": "9d3e283e-28fa-49ae-8f21-4596ae4cd2f5"
  },
  {
    "created_at": "2025-05-26T06:00:14.426532Z",
    "updated_at": "2025-06-02T22:24:53.962757Z",
    "featured": false,
    "name": "שיחה ישראלית חדשה",
    "id": "988b11c3-50de-4f6d-8943-6be9881e1636"
  },
  {
    "created_at": "2025-05-26T06:00:57.501643Z",
    "updated_at": "2025-06-02T22:24:57.746019Z",
    "featured": false,
    "name": "רבי מכר",
    "id": "4423a8a4-0b13-417d-abf1-0b7817a1ed70"
  },
  {
    "created_at": "2025-05-26T06:00:07.332600Z",
    "updated_at": "2025-06-02T22:25:01.421966Z",
    "featured": false,
    "name": "הספרייה העסקית",
    "id": "b2292f32-a476-4dc4-8142-e74fec0e8861"
  },
  {
    "created_at": "2025-05-26T06:00:47.787325Z",
    "updated_at": "2025-06-02T22:25:04.273459Z",
    "featured": false,
    "name": "ספרי מופת מתורגמים",
    "id": "b889784c-377b-4a0a-9381-03e85d8e5e51"
  }
]